import { render, staticRenderFns } from "./photo_home.vue?vue&type=template&id=ab12506e"
import script from "./photo_home.vue?vue&type=script&lang=js"
export * from "./photo_home.vue?vue&type=script&lang=js"
import style0 from "./photo_home.vue?vue&type=style&index=0&id=ab12506e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports